define([
  "globals",
  "knockout",
  "postal",
  "jquery",
  "underscore",
  "cookies-factory",
  "colorbox",
], function(globals, ko, postal, $, _, cookiesFactory) {

  var updateSampleCartCookie = function(size) {
    var thdCookieDomain = globals.thdCookieDomain;
    if (thdCookieDomain === undefined) {
      return; //don't set cookie unless we are on THD
    }

    var now = new Date();
    now.setDate(now.getDate() + 30);
    document.cookie = "Blinds_ComCartSamplesCount=" + size + ";path=/;expires=" + now.toUTCString() + ";domain=" + thdCookieDomain;
    if (window.showBlindsSampleCartBlock !== undefined && typeof(window.showBlindsSampleCartBlock) === "function") {
      showBlindsSampleCartBlock();
    }

    $(document).trigger({
      type: "cartUpdated"
    });
  };

  var updateTHDHeaderCartCount = function(action) {
    var thdCookieDomain = globals.thdCookieDomain;
    var itemCountElement = $(".MyCart__itemCount");
    if (thdCookieDomain !== undefined) {
      var thdCartTotalItemCount = parseInt($(".MyCart__itemCount").text());
      if (!isNaN(thdCartTotalItemCount)) {
        if (action === "add") {
          itemCountElement.text(thdCartTotalItemCount + 1);
        } else if (action === "remove") {
          if ((thdCartTotalItemCount - 1) === 0) {
            $("#headerCart").removeClass("headerCart__button--replete");
            itemCountElement.text("0");
          } else {
            itemCountElement.text(thdCartTotalItemCount - 1);
          }
        }
      } else {
        if (action === "add") {
          itemCountElement.text("1");
          $("#headerCart").addClass("headerCart__button--replete");
        } else if (action === "remove") {
          itemCountElement.text("0");
          $("#headerCart").removeClass("headerCart__button--replete");
        }
      }
    }
  };

  var sampleCart = function() {

    var self = this;
    var channel = postal.channel("productpage");
    var cartChannel = postal.channel("cart");

    self.samples = ko.observableArray();

    self.sampleRemove = function(sample) {
      if (globals.paths.removeSample !== undefined) {
        $.post(globals.paths.removeSample, sample, function() {
          self.samples.remove(sample.choiceId);
          updateSampleCartCookie(self.samples().length);
          updateTHDHeaderCartCount("remove");
          channel.publish("sample.removed", sample.choiceId);
          cartChannel.publish("cart.list.updated");
          self.UpdateProductPreviewMicroApp();
        });
      } else {
        self.samples.remove(sample.choiceId);
        updateSampleCartCookie(self.samples().length);
        updateTHDHeaderCartCount("remove");
        channel.publish("sample.removed", sample.choiceId);
        cartChannel.publish("cart.list.updated");
        self.UpdateProductPreviewMicroApp();
      }
    };

    self.addSample = function(sample) {
      var isMobile = globals.ssm.getState("mobile").options.observableIsActive();
      var isDesktop = globals.ssm.getState("desktop").options.observableIsActive();
      $.post(globals.paths.addSample, sample, function() {
        self.samples.push(sample.choiceId);
        updateSampleCartCookie(self.samples().length);
        channel.publish("sample.added", sample.choiceId);
        cartChannel.publish("cart.list.updated");
        updateTHDHeaderCartCount("add");
        self.UpdateProductPreviewMicroApp();

        var thdAnalyticsEvent = {
          category: {
            primaryCategory: "button submission"
          },
          eventInfo: {
            eventName: "cart add"
          },
          item: [{
            productInfo: {
              sku: sample.sampleProductId,
              productCategory: "", // samples category shall be empty string
              productName: sample.productName,
              productType: "sample",
              option: {
                color: sample.name,
                price: 0 // samples option price shall be zero
              },
              manufacturer: "" // samples manufacturer shall be empty string
            },
            quantity: 1,
            price: {
              basePrice: 0 // samples base price shall be zero
            }
          }]
        };

        if (window.ddoEventInit) {
          window.ddoEventInit(thdAnalyticsEvent);
        };

        if (globals.thdCookieDomain !== undefined && !cookiesFactory.isInternalUser()) {
          var $obj = $('<div>').append($('.bdc-product-samples-cart').clone());
          $obj.find('.bdc-product-samples-cart').removeClass('dn');
          const $sampleCount = $obj.find('[data-testid=orderSamplesCount]');
          $sampleCount.css('opacity', 1);
          $obj.find('[data-id="free-samples-continue"]').show();
          $.colorbox({
            html: $obj.html(),
            transition: 'none',
            width: '400px',
            maxWidth: '300px',
            className: 'thd-sample-cart-modal',
            scrolling: false,
            onCleanup: function() {
              var offset = $('.bdc-product-samples-cart').offset();
              for (var i = 0; i < 2; i++) {
                $('#colorbox').animate({
                  position: 'absolute',
                  left: offset.left,
                  top: offset.top,
                  opacity: 0,
                });
              }
            },
          });
        }
      });
    };

    self.UpdateProductPreviewMicroApp = function() {
      const detail = {
        samplesInCart: self.samples().length,
      };
      window.dispatchEvent(new CustomEvent('product-preview', { bubbles: false, cancelable: true, detail }));
    };

    self.shouldConvertLinkToButton = ko.computed(function() {
      var isMobile = globals.ssm.getState("mobile").options.observableIsActive();
      if (isMobile && (globals.siteId == 3 || globals.siteId == 2)) {
        return true;
      } else {
        return false;
      }
    });

    cartChannel.subscribe("cart.contains.samples", function(samples) {
      var sampleIds = [];
      _.each(samples, function(sampleId) {
        sampleIds.push(sampleId);
      });
      self.samples.push.apply(self.samples, sampleIds);
      updateSampleCartCookie(samples.length);
    });

    cartChannel.subscribe("cart.samples.purchased", function() {
      updateSampleCartCookie(0);
    });

    channel.subscribe("sample.add", function(sample) {
      self.addSample(sample);
    });

    channel.subscribe("sample.remove", function(sample) {
      self.sampleRemove(sample);
    });

    cartChannel.subscribe("sample.add", function(sample) {
      self.addSample(sample);
    });

    cartChannel.subscribe("sample.remove", function(sample) {
      self.sampleRemove(sample);
    });

    this.init = function() {
      $.get(globals.paths.getSampleCart, {}, function(data) {
        updateSampleCartCookie(data.Data.length);
        _.each(data.Data, function(item) {
          self.samples.push(item.ChoiceId);
          channel.publish("sample.added", item.ChoiceId);
        });
      });
      var cartArea = $(".bdc-product-samples-cart");
      if (cartArea.length > 0) {
        ko.applyBindings(self, cartArea.get(0));
      }
    };
  };

  return sampleCart;

});
